import translationEn from './translations/en/translationEn.json';
// import translationEl from './translations/el/translationEl.json';
import translationDe from './translations/de/translationDe.json';
import translationPt from './translations/pt/translationPt.json';
// import translationSl from './translations/sl/translationSl.json';
import translationPl from './translations/pl/translationPl.json';
// import translationIt from './translations/it/translationIt.json';
import translationRo from './translations/ro/translationRo.json';

import {
  CountryToLanguage,
  CustomDatepickerLocaleKey,
  SupportedLanguages,
  TranslationJson
} from './types';
import { languageOptions } from './languageOptions';

// Когда добавляем или удаляем язык - нужно не забыть добавить или удалить еще и в customDatepickerLocales, CustomDatepickerLocaleKey (используются в кастомном календаре)

export const SUPPORTED_LANGUAGES = {
  en: true,
  // au: true,
  // nz: true,
  // ca: true,
  // es: true,
  // fr: true,
  // el: true,
  de: true,
  pt: true,
  // sl: true,
  // pl: true,
  // it: true,
  // ro: true,
  gb: true
};

export const COUNTRY_TO_LANG: Record<CountryToLanguage, SupportedLanguages> = {
  EN: 'en',
  DEU: 'de',
  // FRA: 'fr',
  // RO: 'ro',
  // IT: 'it',
  // SL: 'sl',
  // PL: 'pl',
  PT: 'pt',
  // EL: 'el',
  // ES: 'es',
  // AU: 'au',
  // NZ: 'nz',
  // CA: 'ca',
  GB: 'gb'
};

export const arrayLanguagesOptions = Object.values(languageOptions);

export const LS_LANGUAGE_KEY = 'language';

export const resources: Record<SupportedLanguages, { translation: TranslationJson }> = {
  en: {
    translation: translationEn
  },
  gb: {
    translation: translationEn
  },
  // au: {
  //   translation: translationEn
  // },
  // nz: {
  //   translation: translationEn
  // },
  // ca: {
  //   translation: translationEn
  // },
  // es: {
  //   translation: translationEs
  // },
  // fr: {
  //   translation: translationFr
  // },
  // el: {
  //   translation: translationEl
  // },
  de: {
    translation: translationDe
  },
  pt: {
    translation: translationPt
  }
  // sl: {
  //   translation: translationSl
  // },
  // pl: {
  //   translation: translationPl
  // },
  // it: {
  //   translation: translationIt
  // },
  // ro: {
  //   translation: translationRo
  // }
};

export const customDatepickerLocales: Record<
  CustomDatepickerLocaleKey,
  () => Promise<{ name: string }>
> = {
  // au: () => import('dayjs/locale/en-au'),
  // ca: () => import('dayjs/locale/en-ca'),
  de: () => import('dayjs/locale/de'),
  // el: () => import('dayjs/locale/el'),
  gb: () => import('dayjs/locale/en'),
  en: () => import('dayjs/locale/en'),
  // es: () => import('dayjs/locale/es'),
  // fr: () => import('dayjs/locale/fr'),
  // nz: () => import('dayjs/locale/en'),
  pt: () => import('dayjs/locale/pt')
  // ro: () => import('dayjs/locale/ro')
  // sl: () => import('dayjs/locale/sl'),
  // pl: () => import('dayjs/locale/pl')
  // it: () => import('dayjs/locale/it')
};
